import React from "react";
import logo from "../assets/images/CWA_logo.png"; 
import { LocationOn, Email, Phone } from "@mui/icons-material";

function Footer() {
  return (
    <>
      {/* Footer Main Section */}
      <div className="bg-[#FCFFD5] text-black py-16 px-6 pl-10 md:pl-25"> 
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-start gap-6">
          
          {/* Left Section - Logo & Description */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
          <img
  src={logo}
  alt="Temple Logo"
  className="w-44 h-auto mb-4 object-contain cursor-pointer"
  onClick={() => (window.location.href = "/")}
/>
            <p className="text-sm max-w-xs leading-relaxed">
              We invite you to join us in our mission and contribute to the
              betterment of our community.
            </p>
          </div>

          {/* Middle Section - Quick Links */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
            <h3 className="font-bold text-xl mb-4 text-gray-900">Quick Links</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/#contact-section" className="hover:text-red-500 transition duration-300">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-red-500 transition duration-300">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-red-500 transition duration-300">
                  Privacy Policy
                </a>
              </li>
              <li>
               <a href="/#faq-section" className="hover:text-red-500 transition duration-300">
                 FAQ
               </a>
            </li>
            </ul>
          </div>

          {/* Right Section - Contact Information */}
          <div className="w-full md:w-1/3 flex flex-col items-start text-left">
            <h3 className="font-bold text-xl mb-4 text-gray-900">Contact Us</h3>
            <p className="flex items-center mt-2 ">
              <LocationOn className="text-red-500 mr-2" /> Project Office, Chennai
            </p>
            <p className="flex items-center mt-2">
              <Email className="text-red-500 mr-2" />
              <a href="mailto:tsct041224@gmail.com" className="text-black hover:underline">
                tsct041224@gmail.com
              </a>
            </p>

            <p className="flex items-center mt-2">
              <Phone className="text-red-500 mr-2" /> +91 9841818740
            </p>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <footer className="bg-[#FAD707] text-black p-4 text-center">
        <div className="container mx-auto">
          <span>©2025 Thirukadaiyur Senaithalaivar Charitable Trust. All Rights Reserved.</span>
        </div>
      </footer>
    </>
  );
}

export default Footer;